<template>
<div>
    <zm-select v-model="selectedTopic" placeholder="select a topic" size="small" filterable clearable class="status-select">
        <zm-option v-for="item in topicChannelMap" :key="item.name" :label="item.name" :value="item.data"></zm-option>
    </zm-select>
    <zm-button size="small" @click="fetchData()" class="btn-in-line" type="primary" plain :loading="loading">Refresh</zm-button>
    <zm-table :data="clusterData" v-loading="loading">
        <zm-table-column type="expand">
            <template slot-scope="scope">
                <zm-table :data="scope.row.nodeInfo" border>
                    <zm-table-column prop="host" label="host" align="center"></zm-table-column>
                    <zm-table-column prop="nodeRole" label="nodeRole" align="center"></zm-table-column>
                    <zm-table-column prop="nodeStatus" label="nodeStatus" align="center"></zm-table-column>
                </zm-table>
            </template>
        </zm-table-column>
        <zm-table-column prop="name" label="Cluster"></zm-table-column>
        <zm-table-column prop="clusterStatus" label="Status" width="100px">
            <template slot-scope="scope">
                <img class="point" v-if="scope.row.clusterStatus === 'RED'" src="../../assets/red-point.png">
                <img class="point" v-if="scope.row.clusterStatus === 'GREEN'" src="../../assets/green-point.png">
                <img class="point" v-if="scope.row.clusterStatus === 'YELLOW'" src="../../assets/yellow-point.png">
            </template>
        </zm-table-column>
    </zm-table>
</div>
</template>
<script>
import { getMQClusterStatus } from '@/api'
export default {
    name: 'status',
    data () {
        return {
            loading: false,
            selectedTopic: [],
            clusterInfoMap: [],
            topicChannelMap: []
        }
    },
    created () {
        localStorage.params = ''
        localStorage.path = this.$route.path
        this.fetchData()
    },
    computed: {
        clusterData () {
            if (this.selectedTopic.length) {
                return this.clusterInfoMap.filter(data => {
                    return this.selectedTopic.indexOf(data.name) > -1
                })
            }
            return this.clusterInfoMap
        }
    },
    methods: {
        fetchData () {
            this.selectedTopic = []
            this.clusterInfoMap = []
            this.topicChannelMap = []
            this.loading = true
            getMQClusterStatus().then(response => {
                this.loading = false
                Object.keys(response.clusterInfoMap).map(item => {
                    this.clusterInfoMap.push({
                        name: item,
                        clusterStatus: response.clusterInfoMap[item].clusterStatus,
                        nodeInfo: response.clusterInfoMap[item].nodeInfo
                    })
                })
                Object.keys(response.topicChannelMap).map(item => {
                    this.topicChannelMap.push({
                        name: item,
                        data: response.topicChannelMap[item]
                    })
                })
            }).catch(() => {
                this.loading = false
            })
        }
    }
}
</script>
<style scoped>
.status-select {
    float: right;
    margin: 0 10px;
    width: 300px;
}
</style>
